import { EvilIcons } from "@expo/vector-icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { View, TextInput } from "react-native";

interface InputSearchProps {
  onSearchChange?: (term: string) => void;
}

export default function InputSearch(props: InputSearchProps) {
  const { t } = useTranslation();

  return (
    <View className="items-center">
      <EvilIcons
        name="search"
        size={22}
        color="#BDBDBD"
        className="z-50 absolute top-4 left-3"
      />
      <TextInput
        className="bg-white1 border border-midgray text-sm border-solid rounded-xl items-center py-6 pl-10 w-80 h-14 text-black1"
        onChangeText={(term) => {
          props.onSearchChange(term);
        }}
        placeholder={t("common:placeholder.beneficiary")}
        placeholderTextColor="#BDBDBD"
      />
    </View>
  );
}
